class Background implements ng.IComponentController {
    bgStyle: anm.WaveBackground;
    imageUrl: string;
    private style: any;

    constructor() {
        if (this.imageUrl) {
            this.style = {
                'background-image': `url(${this.imageUrl})`
            }
        }
    }
}

angular.module('animatronApp.background', []).component('background', {
    bindings: {
        bgStyle: '@',
        imageUrl: '<'
    },
    transclude: true,
    controller: Background,
    template: `<div 
                class="background {{ $ctrl.bgStyle }}" 
                ng-style="$ctrl.style" 
                ng-transclude
              ></div>`
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/Background.ts